module.exports = __webpack_public_path__ + "static/media/wallet-deposit-image.b483dfa4.svg";